import { render, staticRenderFns } from "./friends.vue?vue&type=template&id=28def14d&"
import script from "./friends.vue?vue&type=script&lang=js&"
export * from "./friends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports